import Slider from './slider'

Slider.install = vue => {
  vue.component(Slider.name, Slider)
}

export default Slider
